// removed by extract-text-webpack-plugin
module.exports = {"header":"subject-summary__header___2Enrh","treatmentStatus":"subject-summary__treatmentStatus___3GnVC","treatmentActive":"subject-summary__treatmentActive___OAAON","treatmentInactive":"subject-summary__treatmentInactive___lvBpY","treatmentArchived":"subject-summary__treatmentArchived___a2-qv"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/components/subjects/subject-summary.css
// module id = 1217
// module chunks = 0